import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Field, useFormikContext } from "formik";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import clsx from "clsx";
import InputLabel from "@material-ui/core/InputLabel";

import useStyles from "assets/jss/material-dashboard-react/components/customSearchableSelectStyle";
import { getObjectFromCurrentValue } from "utils";
import ErrorMessage from "@Components/ErrorMessage";
import { useTranslation } from "react-i18next";

const Select = (props) => {
  const { t } = useTranslation();
  const {
    label,
    favouriteLabel,
    divider,
    required,
    name,
    options,
    dependentOn,
    errorMessage,
    ...rest
  } = props;
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const classes = useStyles();
  const formik = useFormikContext();
  useEffect(() => {
    setValue(getObjectFromCurrentValue(formik.values[name], options));
    
    
  }, [formik.values[name], options]);

  const handleChange = (event, value) => {
    setValue(value);
  };

  useEffect(() => {
    if (value) {
      formik.setFieldValue(name, value.id);
    } else {
      formik.setFieldValue(name, null);
    }
  }, [value]);

  useEffect(() => {
    if (!formik.values[dependentOn]) {
      setValue(null);
    }
  }, [formik.values[dependentOn]]);

  const modifiedOptions = options.map((option) => {
    return {
      favLabel: option.fav ? favouriteLabel : divider,
      ...option,
    };
  });

  return (
    <Field name={name} multiple>
      {(props) => {
        const { meta } = props;
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classes.label, {
                [classes.error]: errorMessage || (meta.error && meta.touched),
              })}
            >
              {t(label)}
              {required ? <span style={{ color: "red" }}> *</span> : null}
            </InputLabel>
            <Autocomplete
              className={classes.autoComplete}
              clearOnBlur
              blurOnSelect
              id={name}
              name={name}
              options={modifiedOptions}
              value={value}
              renderOption={(option) => (
                <span style={{ textTransform: "uppercase" }}>
                  {option.name}
                </span>
              )}
              getOptionLabel={(option) => option.name}
              groupBy={(option) => (option.favLabel ? option.favLabel : null)}
              onChange={handleChange}
              inputValue={inputValue}
              onInputChange={(event, newInputValue, reason) => {
                if (reason === "clear") {
                  setValue(null);
                  formik.setFieldValue(name, null);
                } else {
                  setInputValue(newInputValue);
                }
              }}
              renderInput={(params) => (
                <TextField
                  margin="normal"
                  variant="outlined"
                  placeholder={t("Select " )+ t(label)}
                  fullWidth
                  name={name}
                  {...params}
                />
              )}
              {...rest}
            />
            <ErrorMessage message={errorMessage ? errorMessage : meta.error} />
          </>
        );
      }}
    </Field>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  favouriteLabel: PropTypes.string,
  divider: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  options: PropTypes.array,
  setOptions: PropTypes.func,
  dependentOn: PropTypes.string,
  recordForEdit: PropTypes.object,
  errorMessage: PropTypes.array,
  url: PropTypes.string,
  field: PropTypes.object,
  meta: PropTypes.object,
  form: PropTypes.object,
};

export default Select;
